// Import FontAwesome core
import { library } from '@fortawesome/fontawesome-svg-core';

// Import specific icons we need
import {
    faSearch,
    faSearchPlus,
    faTimesCircle,
    faShip,
    faSort,
    faSortUp,
    faSortDown,
    faTimes,
    faList,
    faPlus,
    faMinus,
    faSignInAlt,
    faSignOutAlt,
    faCog,
    faGripHorizontal,
    faChevronLeft,
    faUser,
    faUserCircle,
    faCheck,
    faArchive,
    faFileAlt,
    faCalendarCheck,
    faChevronRight,
    faCaretRight,
    faExclamationCircle,
    faCheckCircle,
    faChevronDown,
    faChevronUp,
    faFilter,
    faCodeBranch,
    faThumbtack,
    faDolly,
    faFill,
    faPencilAlt,
    faStarOfLife,
    faWater,
    faMinusCircle,
    faMinusSquare,
    faBell,
    faWifi,
    faPen,
    faEdit,
    faPenSquare,
    faTrash,
    faArrowsAlt,
    faArrowCircleRight,
    faArrowCircleLeft,
    faArrowLeft,
    faCircle,
    faNotEqual,
    faExclamationTriangle,
    faExclamation,
    faSlidersH,
    faSortAmountUp,
    faSortAmountDown,
    faSortAmountDownAlt,
    faTh,
    faClock,
    faExchangeAlt,
    faInfoCircle,
    faExternalLinkAlt,
    faPrint,
    faProjectDiagram,
    faEnvelope,
    faQuestionCircle,
    faEllipsisV,
    faEllipsisH,
    faInfo,
    faBroom,
    faDatabase,
    faStar,
    faComment,
    faTemperatureHigh,
    faListOl,
    faCertificate,
    faTable,
    faChartLine,
    faArrowUp,
    faArrowDown,
    faAngleDoubleDown,
    faAngleDoubleLeft,
    faAngleDoubleUp,
    faAngleDoubleRight,
    faGasPump,
    faEye,
    faExternalLinkSquareAlt,
    faCompress,
    faBars,
    faWindowClose,
    faUpload,
    faBan,
    faSyncAlt,
    faHandPointer,
    faRotateLeft,
    faRotateRight,
    faUpDownLeftRight,
    faWeightHanging,
    faScaleUnbalancedFlip,
    faCaretDown,
    faCopy,
    faShareFromSquare,
    faBook,
    faChevronCircleDown,
    faChevronCircleUp,
    faFilePdf,
    faFileExcel,
    faUndo,
    faArrowsAltH,
    faRefresh,
    faBox,
    faWrench,
    faHistory,
    faTools,
    faUserShield
} from '@fortawesome/free-solid-svg-icons';

// Add icons to library
library.add([
    faSearch,
    faSearchPlus,
    faRotateLeft,
    faRotateRight,
    faTimesCircle,
    faShip,
    faList,
    faPlus,
    faMinus,
    faMinusCircle,
    faMinusSquare,
    faSignInAlt,
    faTimes,
    faSignOutAlt,
    faSort,
    faSortUp,
    faSortDown,
    faCog,
    faGripHorizontal,
    faUser,
    faUserCircle,
    faCheck,
    faCheckCircle,
    faArchive,
    faFileAlt,
    faCalendarCheck,
    faChevronRight,
    faChevronLeft,
    faChevronDown,
    faChevronUp,
    faCodeBranch,
    faStarOfLife,
    faArrowCircleLeft,
    faThumbtack,
    faDolly,
    faCaretRight,
    faFill,
    faPencilAlt,
    faFilter,
    faWater,
    faBell,
    faWifi,
    faPen,
    faEdit,
    faPenSquare,
    faTrash,
    faArrowsAlt,
    faArrowCircleRight,
    faArrowLeft,
    faTimesCircle,
    faCircle,
    faNotEqual,
    faExclamationTriangle,
    faExclamation,
    faExclamationCircle,
    faSortAmountUp,
    faSlidersH,
    faSortAmountDown,
    faSortAmountDownAlt,
    faTh,
    faClock,
    faExchangeAlt,
    faInfoCircle,
    faExternalLinkAlt,
    faPrint,
    faProjectDiagram,
    faEnvelope,
    faQuestionCircle,
    faEllipsisV,
    faEllipsisH,
    faInfo,
    faBroom,
    faDatabase,
    faStar,
    faComment,
    faTemperatureHigh,
    faListOl,
    faCertificate,
    faTable,
    faChartLine,
    faArrowUp,
    faArrowDown,
    faAngleDoubleDown,
    faAngleDoubleLeft,
    faAngleDoubleUp,
    faAngleDoubleRight,
    faGasPump,
    faEye,
    faExternalLinkSquareAlt,
    faCompress,
    faBars,
    faWindowClose,
    faUpload,
    faBan,
    faSyncAlt,
    faHandPointer,
    faUpDownLeftRight,
    faWeightHanging,
    faScaleUnbalancedFlip,
    faCaretDown,
    faCopy,
    faShareFromSquare,
    faBook,
    faChevronCircleDown,
    faChevronCircleUp,
    faFilePdf,
    faFileExcel,
    faUndo,
    faArrowsAltH,
    faRefresh,
    faBox,
    faWrench,
    faHistory,
    faTools,
    faUserShield
]);